import type { FC } from 'react';
import Dropdown from '@/components/elements/Dropdown';
import { FaSignOutAlt, FaReceipt } from 'react-icons/fa';
import { useUser } from '@/state/UserContext';
import { useAuthActions } from '@/hooks/useAuthActions';

const AccountManagementDropdown: FC = () => {
  const { email } = useUser();
  const { handleLogout } = useAuthActions();

  const options = [
    { label: 'Subscriptions', icon: FaReceipt, to: '/me/purchases' },
    { label: 'Logout', icon: FaSignOutAlt, onClick: handleLogout, dividerAbove: true },
  ];

  return (
    <Dropdown
      options={options}
      dataCy='account-management-dropdown'
      header={
        <span className='font-medium tracking-tight'>
          Logged in as <b>{email}</b>
        </span>
      }
      toggleButtonContent={<img src='/userprofile.svg' alt='EklpiX Research Profile' height={18} width={18} />}
    />
  );
};

export default AccountManagementDropdown;
